var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 22 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M11 4.167v11.666M5.167 10h11.666"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.8d265ee08cbb9eca787d1d916b8e010c.svg";